"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zodUnknownFieldDefaultSchema = void 0;
exports.adjustZodSchemaDefaultForUnknownFields = adjustZodSchemaDefaultForUnknownFields;
const zod_1 = require("zod");
const recurseZodObjectSchema_1 = require("./recurseZodObjectSchema");
/**
 * Default schema to validate unknown/dynamic fields with {@link adjustZodSchemaDefaultForUnknownFields}
 */
exports.zodUnknownFieldDefaultSchema = zod_1.z.lazy(() => zod_1.z.union([
    zod_1.z.string().max(2000),
    zod_1.z.number(),
    zod_1.z.boolean(),
    zod_1.z.null(),
    zod_1.z.undefined(),
    zod_1.z.array(exports.zodUnknownFieldDefaultSchema).max(100),
    zod_1.z.record(exports.zodUnknownFieldDefaultSchema).refine((obj) => Object.keys(obj).length <= 100, { message: 'too many record keys' }),
    zod_1.z.record(zod_1.z.string(), zod_1.z.array(exports.zodUnknownFieldDefaultSchema)),
]));
/**
 * Extend Zod z.object schema to support additional (unknown/dynamic) fields with default validation
 * Recursive - validates nested unknown fields
 *
 * @param schema - original zod object schema
 * @param unknownFieldSchema - schema to validate additional unknown/dynamic fields
 * @return original schema that supports and validates additional unknown/dynamic fields
 *
 * @example
 * // original schema - does not allow unknown fields
 * const schemaOriginal = z.object({...});
 * // new schema - same as original, but allows and validates unknown fields
 * const schemaNew = adjustZodSchemaDefaultForUnknownFields(schemaOriginal);
 * @example
 */
function adjustZodSchemaDefaultForUnknownFields(schema, unknownFieldSchema = exports.zodUnknownFieldDefaultSchema) {
    return (0, recurseZodObjectSchema_1.recurseZodObjectSchema)(schema, {
        adjustRecurseResult: (res) => res.catchall(unknownFieldSchema),
    });
}
